<template>
  <footer class="yj-footer">
    <div class="yj-footer__inner">
      <!-- 主体信息 -->
      <div class="yj-footer__main">
        <!-- 左侧联系信息 -->
        <div class="yj-footer__contact">
          <div class="contact-label">咨询服务热线</div>
          <div class="contact-phone">400-8660808</div>
          <div class="contact-item">
            公司地址：武汉市东湖新技术开发区软件园中路4号光谷软件园六期4栋5层03室4号
          </div>
          <div class="contact-item">市场合作：yjszkj2025@163.com</div>
        </div>

        <!-- 中间菜单 -->
        <div class="yj-footer__menu">
          <div class="menu-col">
            <div class="menu-title">快速导航</div>
            <a class="menu-link" @click="$router.push('/')">首页</a>
            <a class="menu-link" @click="$router.push('/product')">产品中心</a>
            <a class="menu-link" @click="$router.push('/case')">成功案例</a>
            <a class="menu-link" @click="$router.push('/about')">关于云稼</a>
            <a class="menu-link" @click="$router.push('/contact')">联系我们</a>
          </div>
          <div class="menu-col">
            <div class="menu-title">解决方案一</div>
            <a class="menu-link" @click="$router.push('/solution/digitalSupply')">数字供销全域治理</a>
            <a class="menu-link" @click="$router.push('/solution/smartAgri')">智慧农业生产数字化</a>
            <a class="menu-link" @click="$router.push('/solution/agriSupply')">农资供应链数字化</a>
            <a class="menu-link" @click="$router.push('/solution/agriService')">农业社会化服务生态</a>
            <a class="menu-link" @click="$router.push('/solution/productTrace')">农产品产销溯源</a>
          </div>
          <div class="menu-col">
            <div class="menu-title">解决方案二</div>
            <a class="menu-link" @click="$router.push('/solution/aiAgent')">云小稼 AI 智能体</a>
            <a class="menu-link" @click="$router.push('/solution/dataTwin')">数据智能与孪生可视化</a>
            <a class="menu-link" @click="$router.push('/solution/customDev')">定制化平台开发</a>
          </div>
        </div>

        <!-- 右侧二维码 -->
        <div class="yj-footer__qrcode">
          <div class="qrcode-title">关注我们</div>
          <div class="qrcode-img">
            <img src="@/assets/code/gzhao.jpg" alt="微信公众号" />
          </div>
          <div class="qrcode-tip">微信公众号</div>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="yj-footer__bottom">
        <div class="copyright">
          ©2017-2036 yunjia technology company 武汉云稼数字科技有限公司版权所有
        </div>
        <div class="record" @click="record">鄂ICP备2022011496号-3</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    record() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<style lang="scss" scoped>
.yj-footer {
  width: 100%;
  background-color: #1b1f25;
  color: #ffffff;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;

  &__inner {
    width: 1196px;
    margin: 0 auto;
    padding: 32px 0 39px 0;
    box-sizing: border-box;
  }

  &__main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__contact {
    flex: 0 0 349px;
    padding-right: 40px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    .contact-label {
      font-size: 16px;
      color: #ffffff;
      //   line-height: 20px;
      margin-bottom: 8px;
    }

    .contact-phone {
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      //   line-height: 44px;
      margin-bottom: 24px;
      letter-spacing: 1px;
    }

    .contact-item {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 22px;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__menu {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 0 40px;

    .menu-col {
      flex: 1;
      margin-right: 80px;

      &:last-child {
        margin-right: 0;
      }
    }

    .menu-title {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      margin-bottom: 24px;
    }

    .menu-link {
      display: block;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 24px;
      margin-bottom: 12px;
      text-decoration: none;
      transition: color 0.2s ease;
      cursor: pointer;

      &:hover {
        color: #ffffff;
      }
    }
  }

  &__qrcode {
    flex: 0 0 88px;
    text-align: center;

    .qrcode-title {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      margin-bottom: 17px;
    }

    .qrcode-img {
      width: 88px;
      height: 88px;
      background-color: #ffffff;
      //   border-radius: 4px;
      overflow: hidden;
      margin-bottom: 12px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .qrcode-tip {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 21px;
    }
  }

  &__bottom {
    padding-top: 30px;
    // border-top: 1px solid rgba(255, 255, 255, 0.08);

    .copyright {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 18px;
      margin-bottom: 8px;
    }

    .record {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 18px;
      cursor: pointer;
      display: inline-block;
      transition: color 0.2s ease;

      &:hover {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>
